import { FunctionComponent } from "react";
import { Step } from "@App/Components/Stepper/Step";
import { useTranslation } from "react-i18next";
import { MileageStep } from "@App/Components/molecules/whitelabel/home/stepper/MileageStep";
import { ChildStepProps } from "@App/Components/molecules/whitelabel/home/stepDefinitions/ChildStepProps";

type MileageStepDefinitionProps = {
  mileage: number | null;
  stepGoBackLinkTitle: string;
  error: string | null;
  onSubmit: (mileage: number) => void;
} & ChildStepProps;

export const MileageStepDefinition: FunctionComponent<MileageStepDefinitionProps> = ({
  mileage,
  onSubmit,
  stepGoBackLinkTitle,
  error,
  ...stepProps
}: MileageStepDefinitionProps) => {
  const { t } = useTranslation();
  return (
    <Step
      {...stepProps}
      title={t("home.steps.mileage.title")}
      completedTitle={`${t("home.steps.mileage.title")}: `}
      completedGoBackLinkTitle={stepGoBackLinkTitle}
    >
      <MileageStep mileage={mileage} onSubmit={onSubmit} error={error} />
    </Step>
  );
};
